import React from 'react';
import Row from '../Symbols/Row';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import InputSelect from '../Symbols/InputSelect';
import Input from '../Symbols/Input';
import InputCurrency from '../Symbols/InputCurrency';
import Wrapper from '../Symbols/Wrapper';
import { LonelyParentVariant } from '../osetrovne/Options';
import { YEARS_OSETROVNE } from '../LegalParameters/Constants';

const years = YEARS_OSETROVNE.map(year => ({ name: year, value: year }));

const emptyFunc = () => {};

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { pay, sickDays, lonelyParent, year },
		result = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka – ošetřovné (dítě, člen rodiny)">
				<InputSelect
					label="Výpočet pro rok:"
					name="years"
					value={year}
					onChange={changeHandler('year')}
					onBlur={validateHandler('year')}
					passedProps={{ 'data-cy': 'year' }}
					select={years}
					error={errors.year}
				/>

				<InputCurrency
					label="Zadejte hrubou mzdu"
					name="pay"
					value={pay}
					onChange={changeHandler('pay')}
					onBlur={validateHandler('pay')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'pay' }}
					error={errors.pay}
				/>

				<Input
					label="Počet kalendářních dní ošetřování"
					name="sickDays"
					value={sickDays}
					type="number"
					onChange={changeHandler('sickDays')}
					onBlur={validateHandler('sickDays')}
					passedProps={{ min: 1, step: 1, 'data-cy': 'sickDays' }}
					error={errors.sickDays}
				/>

				<InputSelect
					label="Jste osamělý rodič"
					name="lonelyParent"
					value={lonelyParent}
					onChange={changeHandler('lonelyParent')}
					onBlur={validateHandler('lonelyParent')}
					passedProps={{ 'data-cy': 'lonelyParent' }}
					select={LonelyParentVariant}
					error={errors.lonelyParent}
				/>

				<div css={Row}>
					<Button data-cy="submit">Výpočet</Button>
				</div>

				{result && <Result osetrovne={result} />}
				{result && (
					<div css={Row}>
						<Button onClick={reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}
			</Form>
		</Wrapper>
	);
};
